import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * Fires when an unauthenticated user taps the “Log In” CTA on the Web Sign Up Modal.
 */
const logWebSignUpModalLogInTapped = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('web sign up modal log in tapped', {}, callback);
};

export default logWebSignUpModalLogInTapped;
